function updateSquarePlacementAmount() {
  const priceElement = document.querySelector('[data-block-type="price"]');
  const squarePlacement = document.querySelector('square-placement');

  if (priceElement && squarePlacement) {
    const priceText = priceElement.textContent.replace(/[^0-9.]/g, '');
    const priceValue = parseFloat(priceText);

    if (!isNaN(priceValue)) {
      squarePlacement.setAttribute('data-amount', priceValue);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Initial update on page load
  updateSquarePlacementAmount();

  // Observe future changes
  const priceElement = document.querySelector('[data-block-type="price"]');
  if (priceElement) {
    const observer = new MutationObserver(() => {
      updateSquarePlacementAmount();
    });

    observer.observe(priceElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
    });
  }
});
